export const EtatCours =
{
  Brouillon: 0,
  Ouvert: 1,
  Complet: 2,
  Annule: 3,
};

export const PorteeCours =
{
  Regional: 0, // Cours
  Local: 1, // Examens
};

export const InscriptionCSS =
{
  CSSMonteregieEstrie: 0,
  AutreCSS: 1,
  EtablissementPrive: 2,
};

export const InscriptionExterne =
{
  CssIdAutreCSS: 0,
  CssIdEcolePrive: 1,
};

export const EtatCoursEleve =
{
  EnAttentePaiement: 0,
  EnAttenteApprobation: 1,
  Approuver: 2,
  Refuser: 3,
  DesistementParParent: 4,
  AbandonSansRemboursement: 5,
  EnCreation: 6,
  ApprouveEnAttentePaiement: 7,
  AnnulerParCSS: 8,
  AnnulerParParent: 9,
  AttenteApproAttentePaiement: 10,
};

export const TypeDocument =
{
  Bulletin: 0,
  PI: 1,
};

export const TypePaiement =
{
  Paypal: 0,
};

export const TypeCours =
{
  Presentiel: 0,
  Virtuel: 1,
  TousLesTypes: -1,
};

export const AdresseDe = {
  PereMere: 1,
  Pere: 2,
  Mere: 3,
  Tuteur: 4,
};

export const EtatPaiement = {
  PasNecessaire: 0,
  APayerPlusTard: 1,
  EnAttente: 2,
  Paye: 3,
};

export const TypeEleve = {
  Inconnu: 0,
  Membre: 1,
  ScolarisationMaison: 2,
  EcolePrive: 3,
  AutreCSS: 4,
};

export const TypeRepondants = {
  Pere: 0,
  Mere: 1,
  Tuteur: 2,
};

export const NiveauScolaire = {
  SecondaireUn: 1,
  SecondaireDeux: 2,
  SecondaireTrois: 3,
  SecondaireQuatre: 4,
  SecondaireCinq: 5,
  TousLesNiveaux: -1,
};

export const RaisonTransaction = {
  PaiementFacture: 0,
  RemboursementAnnulationCours: 1,
  RemboursementAnnulationInscription: 2,
};

export const TypeTransaction = {
  Paiement: 0,
  Remboursement: 1,
};

export const ProvenanceEleve =
{
  CSSMonteregieEstrie: 0,
  CSSExterne: 1,
  EcolePrive: 2,
};
